import { BroadcastRouting } from './BroadcastRouting.jsx';

const BroadcastMessageContainer = () => {
  return <BroadcastRouting />;
};

export default BroadcastMessageContainer;
